<template>
  <div class="integrityComplianceMain">
    <h1>{{$t("integrityCompliance.title")}}</h1>
    <SwitchButtons
      class="mx-0"
      name="integrityComplianceNav"
      :values="menu"
      @tipo="onMenuChanged"
    />
    <div class="integrityComplianceMain__dynamic-content" v-if="!isLoading">
      <Intro v-if="selectedMenu === integrityComplianceKey.main"/>
      <Integrity
        v-if="selectedMenu === integrityComplianceKey.integrity"
        @categoryUpdated="onCategoryUpdated"
      />
      <Compliance @categoryUpdated="onCategoryUpdated" v-if="selectedMenu === integrityComplianceKey.compliance"/>
      <WhistleblowingSystem @categoryUpdated="onCategoryUpdated" v-if="selectedMenu === integrityComplianceKey.whistleblowingSystem"/>
      <RiskManagement @categoryUpdated="onCategoryUpdated" v-if="selectedMenu === integrityComplianceKey.riskManagement"/>
    </div>
  </div>
</template>

<script>
const SwitchButtons = () => import("@/components/Switch");
const Integrity = () => import("@/components/IntegrityCompliance/Integrity/Main");
const Compliance = () => import("@/components/IntegrityCompliance/Compliance/Main");
const Intro = () => import("@/components/IntegrityCompliance/Intro/Intro");
const WhistleblowingSystem = () => import("@/components/IntegrityCompliance/WhistleblowingSystem");
const RiskManagement = () => import("@/components/IntegrityCompliance/RiskManagement/RiskManagement");
import { integrityComplianceKey } from "@/lib/constants.js";

import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

export default {
  data() {
    return {
      isLoading: false,
      selectedMenu: integrityComplianceKey.main,
      integrityComplianceKey,
      modules: []
    }
  },
  provide() {
    return {
      'IC_getMainCategory': () => this.currentModule
    }
  },
  computed: {
    menu() {
      return [
        {
          label: this.$t("integrityCompliance.tabs.main"),
          value: integrityComplianceKey.main
        },
        {
          label: this.$t("integrityCompliance.tabs.integrity"),
          value: integrityComplianceKey.integrity
        },
        {
          label: this.$t("integrityCompliance.tabs.compliance"),
          value: integrityComplianceKey.compliance
        },
        {
          label: this.$t("integrityCompliance.tabs.whistleblowingSystem"),
          value: integrityComplianceKey.whistleblowingSystem
        },
        {
          label: this.$t("integrityCompliance.tabs.riskManagement"),
          value: integrityComplianceKey.riskManagement
        }
      ]
    },
    mainModules () {
      return Object.values(integrityComplianceKey);
    },
    currentModule () {
      const category = this.modules.find(item => item.name === this.selectedMenu);
      return category || {
        id: 0,
        title: '',
        description: {
          ops: []
        }
      };
    }
  },
  components: {
    SwitchButtons,
    Integrity,
    Intro,
    Compliance,
    WhistleblowingSystem,
    RiskManagement
  },
  async created () {
    await this.getModules();
  },
  methods: {
    async getModules () {
      try {
        this.$store.commit("global/SET_LOADING", true);
        this.isLoading = true;
        const categories = await api.getCategories();
        this.modules = categories.filter(category => this.mainModules.includes(category.name))
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
      }
    },
    onMenuChanged(menuKey) {
      this.selectedMenu = menuKey;
    },
    onCategoryUpdated (categoryData) {
      const existingModules = [...this.modules];

      this.modules = existingModules.map(item => {
        if (item.id === categoryData.id) {
          return {
            id: item.id,
            name: categoryData.name,
            title: categoryData.title,
            description: categoryData.description
          }
        } else {
          return item
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .integrityComplianceMain {
    &__dynamic-content {
      margin-top: $global_padding * 2;
    }
  }
</style>
